import { makeStyles } from '@material-ui/core/styles';
import { blueGrey } from '@material-ui/core/colors';
export default makeStyles((theme) => ({

  mainWrapper: {
    height: '100%',
    display: 'flex',
    width: '100%',
    overflow: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0',
  },
  waitingRoomContainer: {
    backgroundColor: blueGrey[100],
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    borderRadius: 5,
    width: '490px',
   //height: '100%',
  },
  formControl: {
    width: '100%',
  },
  mediaSources: {
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  waitingRoomVideoPreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 0px',
    minHeight: '200px',
  },
  deviceContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 5px',
  },
  deviceSettings: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  networkTestContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 5px',
  },
  flex: {
    display: 'flex',
  },
  root: {
    width: '20%',
  },
}));
